import { render } from "./ProposalCantSavingModal.vue?vue&type=template&id=5b73224d"
import script from "./ProposalCantSavingModal.vue?vue&type=script&lang=js"
export * from "./ProposalCantSavingModal.vue?vue&type=script&lang=js"

import "./ProposalCantSavingModal.vue?vue&type=style&index=0&id=5b73224d&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__